import { render, staticRenderFns } from "./ToggleBox.vue?vue&type=template&id=a9c4f38a&scoped=true&"
import script from "./ToggleBox.vue?vue&type=script&lang=js&"
export * from "./ToggleBox.vue?vue&type=script&lang=js&"
import style0 from "./ToggleBox.vue?vue&type=style&index=0&id=a9c4f38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c4f38a",
  null
  
)

export default component.exports